import React from "react";

import Ceo from "./ceo";
import Vision from "./vision";
import History from "./history";
import Organization from "./organization";
import Direction from './direction'

let routes = [];
routes = routes.concat({ path: "/ceo", exact: true, name: "Ceo", component: <Ceo /> });
routes = routes.concat({ path: "/vision", exact: true, name: "Vision", component: <Vision /> });
routes = routes.concat({ path: "/history", exact: true, name: "History", component: <History /> });
routes = routes.concat({ path: "/organization", exact: true, name: "Organization", component: <Organization /> });
routes = routes.concat({ path: "/direction", exact: true, name: "Direction", component: <Direction /> });

export default routes;
